'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useChat } from "../hooks/useChat.js";
import { useConversations } from "../hooks/useConversation.js";
import { markChatLayoutPane } from "../chat/internals/chatLayoutPaneKind.js";
import { useChatLocaleText } from "../chat/internals/ChatLocaleContext.js";
import { ConversationContextProvider } from "./internals/ConversationContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
function getActiveConversation(conversations, activeConversationId) {
  if (activeConversationId == null) {
    return null;
  }
  return conversations.find(conversation => conversation.id === activeConversationId) ?? null;
}
export const ConversationRoot = markChatLayoutPane(/*#__PURE__*/React.forwardRef(function ConversationRoot(props, ref) {
  const {
      children,
      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    activeConversationId
  } = useChat();
  const localeText = useChatLocaleText();
  const conversations = useConversations();
  const conversation = React.useMemo(() => getActiveConversation(conversations, activeConversationId), [activeConversationId, conversations]);
  const ownerState = React.useMemo(() => ({
    conversationId: activeConversationId,
    hasConversation: conversation != null,
    conversation
  }), [activeConversationId, conversation]);
  const Root = slots?.root ?? 'div';
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref,
      // Landmark for the active-conversation (thread) area, so assistive
      // technology can jump between the conversations sidebar, the thread,
      // and the composer.
      role: 'region',
      'aria-label': localeText.threadLandmarkLabel
    }
  });
  return /*#__PURE__*/_jsx(ConversationContextProvider, {
    value: ownerState,
    children: /*#__PURE__*/_jsx(Root, _extends({}, rootProps, {
      children: children
    }))
  });
}), 'thread');
if (process.env.NODE_ENV !== "production") ConversationRoot.displayName = "ConversationRoot";